module.exports = __webpack_public_path__ + "img/list-position-icon.0c97c621.png";